import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Affix from "vue-affix";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import axios from "axios";
import VueAxios from "vue-axios";
import VueNativeSock from "vue-native-websocket";

// WebSocket URL configuration
let wsURL;
const isDevServer = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

if (isDevServer) {
  // Running in development server (npm run serve or serve-production)
  // Use proxy path so webpack dev server can proxy to the correct backend
  const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  wsURL = wsProtocol + "//" + window.location.host + "/ws";
} else {
  // Running in actual production deployment
  wsURL = "wss://www.subastasfts.com.gt/ws";
}

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Affix);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);

import "./assets/scss/bootstrap.scss";
import store from "./store";

// Initialize WebSocket with proper store integration
try {
  Vue.use(VueNativeSock, wsURL, {
    store: store,
    connectManually: true,
    format: "json",
    protocol: "",
    reconnection: false,
  });
} catch (error) {
  console.error('WebSocket initialization failed:', error);
}

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.axios.defaults.baseURL = "/";
Vue.prototype.axios.defaults.headers.common["Authorization"] =
  "Bearer " + store.getters.token;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
